import React from 'react';
import { Header } from './Header';
import { Problem } from './Problem';
import { Solution } from './Solution';
import { Testimonials } from './Testimonials';
import { WebinarDetails } from './WebinarDetails';
import { FAQ } from './FAQ';
import { Benefits } from './Benefits';
import { CallToAction } from './CallToAction';
import { Footer } from './Footer';
import { RegistrationProvider } from './RegistrationContext';
import { RegistrationPopup } from './RegistrationPopup';
import { useRegistration } from './RegistrationContext';
const AdvertorialContent = () => {
  const {
    isPopupOpen,
    closePopup
  } = useRegistration();
  return <div className="max-w-3xl mx-auto px-4 py-6 font-sans text-gray-800" data-id="element-7">
      <Header data-id="element-8" />
      <Problem data-id="element-9" />
      <Solution data-id="element-10" />
      <Testimonials data-id="element-11" />
      <WebinarDetails data-id="element-12" />
      <FAQ data-id="element-13" />
      <Benefits data-id="element-14" />
      <CallToAction data-id="element-15" />
      <Footer data-id="element-16" />
      <RegistrationPopup isOpen={isPopupOpen} onClose={closePopup} data-id="element-17" />
    </div>;
};
export const Advertorial = () => {
  return <RegistrationProvider data-id="element-18">
      <AdvertorialContent data-id="element-19" />
    </RegistrationProvider>;
};